export default
{
    computed:
    {
        monthName()
        {
            return this.locale.monthNames[ this.currentMonthDate.getMonth() ];
        },

        prevMonthClass()
        {
            let prev = this.$dateUtil.prevMonth( this.currentMonthDate ); prev.setHours(0, 0, 0, 0);
            let min  = this.minDate ? new Date( this.minDate ) : null; min && min.setHours(0, 0, 0, 0);

            return ({ 'prev': true, 'disabled': !this.$dateUtil.isValidDate( prev ) || ( min && prev.getMonth() < min.getMonth() ) });
        },

        nextMonthClass()
        {
            let next = this.$dateUtil.nextMonth( this.currentMonthDate ); next.setHours(0, 0, 0, 0);
            let max  = this.maxDate ? new Date( this.maxDate ) : null; max && max.setHours(0, 0, 0, 0);

            return ({ 'next': true, 'disabled': !this.$dateUtil.isValidDate( next ) || ( max && next.getMonth() > max.getMonth() ) });
        },

        year:
        {
            get()
            {
                return this.year_text;
            },
            set( value )
            {
                this.year_text = value;

                let newDate = this.$dateUtil.validateDateRange( new Date( value, this.month, 1 ), this.minDate, this.maxDate );

                if( this.$dateUtil.isValidDate( newDate ) )
                {
                    this.$emit('change-month', { month: newDate.getMonth(), year: newDate.getFullYear() });
                }
            }
        },

        month:
        {
            get()
            {
                return this.currentMonthDate.getMonth() + 1;
            },
            set( value )
            {
                let newDate = this.$dateUtil.validateDateRange( new Date( this.year, value - 1, 1 ), this.minDate, this.maxDate );

                this.$emit('change-month', { month: newDate.getMonth() + 1, year: newDate.getFullYear() });
            }
        },

        calendar()
        {
            let month           = this.month;
            let year            = this.currentMonthDate.getFullYear();
            let firstDay        = new Date( year, month - 1, 1 );
            let lastMonth       = this.$dateUtil.prevMonth( firstDay ).getMonth() + 1;
            let lastYear        = this.$dateUtil.prevMonth( firstDay ).getFullYear();
            let daysInLastMonth = new Date( lastYear, month - 1, 0 ).getDate();
            let dayOfWeek       = firstDay.getDay();
            let calendar        = [];

            for (let i = 0; i < 6; i++)
            {
                calendar[i] = [];
            }

            let startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;

            if( startDay > daysInLastMonth )
            {
                startDay -= 7;
            }

            if( dayOfWeek === this.locale.firstDay )
            {
                startDay = daysInLastMonth - 6;
            }

            let curDate = new Date( lastYear, lastMonth - 1, startDay, 0, 0, 0 );

            for( let i = 0, col = 0, row = 0; i < 6 * 7; i++, col++, curDate.setDate( curDate.getDate() + 1 ) )
            {
                if (i > 0 && col % 7 === 0)
                {
                    col = 0; row++;
                }

                calendar[row][col] = new Date(curDate.getTime());
            }

            return calendar;
        },

        months()
        {
            let monthsData = this.locale.monthNames.map((m, idx) => ({ label: m, value: idx }));

            if( this.maxDate && this.minDate )
            {
                let y = this.maxDate.getFullYear() - this.minDate.getFullYear();

                if( y < 2 )
                {
                    let months = [];

                    if( y < 1 )
                    {
                        for( let i = this.minDate.getMonth(); i <= this.maxDate.getMonth(); i++ )
                        {
                            months.push(i);
                        }
                    }
                    else
                    {
                        for( let i = 0; i <= this.maxDate.getMonth(); i++)
                        {
                            months.push(i);
                        }

                        for( let i = this.minDate.getMonth(); i < 12; i++ )
                        {
                            months.push(i);
                        }
                    }

                    if( months.length > 0 )
                    {
                        return monthsData.filter( ( m ) => { return months.find( i => m.value === i ) > -1; });
                    }
                }
            }

            return monthsData;
        },

        locale ()
        {
            return this.$dateUtil.localeData( this.localeData );
        }
    }
}